#import "../../../../common/graphql/SupplierFields.graphql"
mutation SupplierUpdate($input: SupplierUpdateInput!) {
  supplierUpdate(input: $input) {
    supplier {
      ...SupplierFields
      _isAliasOriginalNameViewable
      _isAliasInvoked
      companyOrLastName
      _pendingApprovers
      firstName
      customerAccount
      _isApproved
      isIndividual
      isCorporation
      paymentTermTypeId
      isRelatedPartySupplier
      isCompetitiveBidsRequired
      isContractualPurchaseOrderRequired
      isEnvironmentalImpactTracked
      environmentalMetricId
      purchaseDocumentsPoolId
      bankAccountName
      bankRoutingNumber
      bankName
      bankSortCode
      bankIbanCode
      bankAccountNumber
      bankSwiftCode
      isDraft
      _isBankAccountVerified
      _isStagedApprovalRequest
      _isApprovalRevocable
      _fullName
      vendorServiceTypeId
      vendorServiceRate
      vendorServiceType {
        isRateRequired
        isServiceRateAllowed
      }
      isW9OnFile
      w9ExpirationDate
      _isPurchaseOrderSettingsUpdatable
      _requiredApprovalDocuments
      _isApprovalDocumentsRequired
      supplierHistoriesByEntityId {
        nodes {
          crudOperation
          pointInTimeDate
          tenantUserName
        }
      }
       supplierAddressesBySupplierId {
        nodes {
          id
          _rowTimestamp
          addressLine1
          addressLine2
          cityName
          countryId
          stateRegionId
          postalCode
          telephoneNumber
          emailAddress
          webAddress
          isSendEmailAccount
          isReceiveEmailAccount
          isPrimary
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          country {
            country
          }
        }
      }
      supplierContactsBySupplierId {
        nodes {
          id
          _rowTimestamp
          contactName
          emailAddress
          telephoneNumber
          isSendEmailAccount
          isReceiveEmailAccount
        }
      }
      approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
        nodes {
          id
          requesterName
          requestedDate
          amount1
          currencyIsoCode
          isApprovalTreeViewerAllowed
          iconType {
            iconType
            iconState
          }
          statusType {
            statusType
          }
        }
      }
    }
  }
}
